import Config from './Config';

class App {
    private static instance: App;

    static getInstance(): App {
        if (!App.instance) {
            App.instance = new App();
        }

        return App.instance;
    }

    isProduction(): boolean {
        return Config.is('app.env', 'production');
    }
}

export default App.getInstance();
